import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { LoadingController } from '@ionic/angular';
import { HttpJsonService } from '../../services/http-json.service.js';

export enum WorkoutType {
  Core = 1,
  Cardio = 2,
  Resistance = 3,
  HIIT = 4
}

export interface WorkoutRoutine {
  id?: string,
  name: string,
  description?: string,
  difficulty?:number, //0=extremely easy, 1=easy, 2=medium, 3=harder, 4=hardest
  group?: number,
  rep?: number,
  repstep?: number,
  weight?: number,
  weightstep?: number,
  time?: number,
  videoId?: string,
  url?: string,
  equipment?: number[],
  reps?: any,
  type?: number,
  category?: number,
  directionUp?: boolean,
  eachside?:boolean,
  prevrep?: number,
  highrep?: number, //when progressive, the highest
  lowrep?: number //when progressive, the lowest
  workout?:number //resistance = 1 or cardio = 2
  round?:number //for progressive, which round the routine belongs to
}

@Component({
  selector: 'round',
  templateUrl: './round.component.html',
  styleUrls: ['./round.component.scss']
})
export class RoundComponent implements OnInit {

  // @Input() equipment: number[];
  @Input() equipment: string;
  @Input() workoutType: number;
  @Input() numberOfRounds: number;
  @Input() numberOfRoutines: number;
  @Output() onClickOk = new EventEmitter();
  @Output() onRoundDone = new EventEmitter();

  workoutData: any;

  routines: WorkoutRoutine[];
  round: WorkoutRoutine[];
  indexes: number[];
  roundNumber: number = 0;
  indexCounter: number = 0;
  allRoutinesShuffledIndexes: number[];

  constructor(public api: HttpJsonService, public loadingController: LoadingController) {
  }

  onSkip(indx: number) {
    this.round[indx] = this.routines[this.api.randomIntFromInterval(0, this.routines.length - 1)];
  }

  onOk(indx: number) {
    this.round.splice(indx, 1);
    if (this.round.length <= 0) {
      this.onNextRound();
    }
    this.onClickOk.emit(this.round.length);
  }

  onNextRound() {
    this.round = new Array<WorkoutRoutine>();
    let sub: number[];
    let lowerBounds = this.numberOfRoutines * this.indexCounter;
    let upperBounds = (this.numberOfRoutines * this.indexCounter + this.numberOfRoutines + 1);

    if (upperBounds >= this.routines.length) {
      this.shuffleRoutineIndexes();
      this.indexCounter = 0;
      lowerBounds = this.numberOfRoutines * this.indexCounter;
      upperBounds = (this.numberOfRoutines * this.indexCounter + this.numberOfRoutines + 1);
    }

    sub = this.allRoutinesShuffledIndexes.slice(lowerBounds, upperBounds);

    for (let i = 0; i < this.numberOfRoutines; ++i) {
      this.round.push(this.routines[(sub[i])]);
    }

    this.onRoundDone.emit(this.roundNumber);

    this.indexCounter++;
    this.roundNumber++;
  }

  shuffleRoutineIndexes() {

    let equipmentToNumberArray: number[] = new Array();
    for (let i = 0; i < this.equipment.length; ++i) {
      // if(this.equipment[i].valueOf()>-1){
      if (parseInt(this.equipment[i]) > -1) {
        equipmentToNumberArray.push(parseInt(this.equipment[i]));
      }
    }

    // this.allRoutinesShuffledIndexes = this.api.getShuffledRoutineIndexes(this.routines, this.routines.length, this.equipment);
    this.allRoutinesShuffledIndexes = this.api.getShuffledRoutineIndexes(this.routines, this.routines.length, equipmentToNumberArray);
  }

  initData() {
    this.api.getData()
      .subscribe(res => {
        this.workoutData = res;
        setTimeout(() => {
          switch (this.workoutType.toString()) {
            case WorkoutType.Core.toString(): {
              this.routines = this.workoutData.core.routines;
              break;
            }
            case WorkoutType.Cardio.toString(): {
              this.routines = this.workoutData.cardio.routines;
              break;
            }
            case WorkoutType.Resistance.toString(): {
              this.routines = this.workoutData.resistance.routines;
              break;
            }
            case WorkoutType.HIIT.toString(): {
              this.routines = this.workoutData.hiit.routines;
              break;
            }
            default: {
              console.log('unknown workout type: ' + this.workoutType);
              break;
            }
          }
          this.shuffleRoutineIndexes();
          this.onNextRound();
        });
      }, err => {
        console.log(err);
      });
  }

  ngAfterViewInit() {
    this.initData();
  }

  ngOnInit() {

    console.log('*********round init');
    // if (typeof this.equipment === 'string') {
    // this.equipment.
    for (let i = 0; i < this.equipment.length; ++i) {
      // if(equipmentNeeded[i].valueOf()>-1){
      // console.log('have num: ' + equipmentNeeded[i]);
    }
    // }

    console.log('**here, is a string');
  }
}

